<template>
    <OpenableMenu>
        <template v-slot:label>
            Plusmin uren vanaf
        </template>
        <template v-slot:content>
            <List>
                <ListItem @click.stop>
                    <CqToggle v-model="showBalancesFromBeginningOfTime" label="Actuele stand" />
                </ListItem>
                <ListItem @click.stop>
                    <CustomDateSelect :modelValue="lastShownPlusMinusBalancesFrom" @update:modelValue="setDate" :disabled="showBalancesFromBeginningOfTime" required :min="beginOfYear" :max="rosterViewSettings.startDate" />
                </ListItem>
            </List>
        </template>
    </OpenableMenu>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {CqToggle} from '@cquential/ui';
    import OpenableMenu from '@/components/Branding/OpenableMenu.vue';
    import ListItem from '@/components/Branding/ListItem.vue';
    import List from '@/components/Branding/List.vue';
    import CustomDateSelect from '@/components/Branding/CustomDateSelect.vue';
    import Dates from '@cquential/date-utils';
    import {RosterViewSettings} from '@/types';

    @Component({
        components: {
            CqToggle,
            OpenableMenu,
            ListItem,
            List,
            CustomDateSelect,
        },
        emits: ['update:showPlusMinusBalancesFrom'],
    })
    export default class ContractHoursOptionsMenu extends Vue {
        @Prop({required: true}) public showPlusMinusBalanceFrom!: Date | false;
        @Prop({required: true}) public rosterViewSettings!: RosterViewSettings;

        public lastShownPlusMinusBalancesFrom: Date | undefined = undefined;

        public mounted(): void {
            this.lastShownPlusMinusBalancesFrom = this.showPlusMinusBalanceFrom || this.rosterViewSettings.startDate;
        }

        public setDate(date?: Date): void {
            if (this.lastShownPlusMinusBalancesFrom && date && date.valueOf() === this.lastShownPlusMinusBalancesFrom.valueOf()) {
                return;
            }

            this.lastShownPlusMinusBalancesFrom = date;
            this.$emit('update:showPlusMinusBalancesFrom', date ?? false);
        }

        public get showBalancesFromBeginningOfTime(): boolean {
            return this.showPlusMinusBalanceFrom === false;
        }

        public set showBalancesFromBeginningOfTime(val: boolean) {
            if (val) {
                this.$emit('update:showPlusMinusBalancesFrom', false);
            } else {
                this.$emit('update:showPlusMinusBalancesFrom', this.lastShownPlusMinusBalancesFrom!);
            }
        }

        public get beginOfYear(): Date {
            return Dates.Utils.startOfYear(this.rosterViewSettings!.startDate);
        }
    }
</script>
